// !!!Entire file is ignored in UNIT TESTS!!!
// BE VERY CAREFULL IF YOU DECIDED TO TINKER HERE
// going around a TypeScript design limitation
// https://github.com/Microsoft/TypeScript/issues/12949
// dirty logic, no way to test -> related to browser feature detection
// and registering custom tag names as HTMLElements
/**
 * Supplies custom tag names to the defineCustomTags function.
 */
/* istanbul ignore file */
export var customTags = {
    "sb-comp": "HTMLElement",
    "sb-error-comp": "HTMLElement",
    "sb-collapsible": "HTMLElement",
    "sb-collapsible-trigger": "HTMLElement",
    "sb-collapsible-block": "HTMLElement",
    "sb-collapsible-content": "HTMLElement",
    "sb-tabs": "HTMLElement",
    "sb-tabs-triggers": "HTMLElement",
    "sb-tab-trigger": "HTMLElement",
    "sb-tabs-blocks": "HTMLElement",
    "sb-tabs-block": "HTMLElement",
    "sb-tabs-content": "HTMLElement",
    "sb-img": "HTMLElement"
};
/**
 * Defines custom tags used for wrapping content
 */
/* tslint:disable */
export function defineCustomTags(tagName, extendsNodeType, tagsCollection) {
    var classes = true;
    /* istanbul ignore next */
    if (typeof customElements !== "undefined" && customElements.get(tagName) === undefined) {
        try {
            eval("class foo{ constructor(){} }");
        }
        catch (e) {
            classes = false;
        }
        var extendsNodeTypeClass = typeof extendsNodeType === "string" && extendsNodeType.length > 0 ? extendsNodeType : "HTMLElement";
        if (classes) {
            eval("window.customElements.define(\"" + tagName + "\", class extends " + extendsNodeTypeClass + " { })");
        }
        else {
            eval("window.customElements.define(\"" + tagName + "\", " + extendsNodeTypeClass + ")");
        }
        typeof tagsCollection === "object" && (tagsCollection[tagName] = extendsNodeTypeClass);
    }
    return true;
}
;
/**
 * Registers all custom tags set in customTags
 */
export function registerCustomTagsFromTagsCollection(collection) {
    Object.keys(collection).forEach(function (tagKey) {
        try {
            defineCustomTags(tagKey, collection[tagKey]);
        }
        catch (e) {
            console.error("Trying to re-init the same custom HTML tag?");
            console.error(e);
        }
    });
}
;
//# sourceMappingURL=CustomTags.js.map